import { client as mediaClient } from '@inference.engine/media-api-client/web';
import { ENV } from '@/lib/config/env';
import { configureApiClient } from './configure-client';

if (!ENV.MEDIA_API_BASE_URL) {
  throw new Error('MEDIA_API_BASE_URL environment variable is not set');
}

mediaClient.setConfig({
  throwOnError: true,
});

export const mediaHttp = configureApiClient(mediaClient, ENV.MEDIA_API_BASE_URL);
